import React from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import PrimaryButton from '../../primaryButton/PrimaryButton'

import Indicators from '../../indicators/Indicators'
import useValidation from '../../../hooks/useValidation'
import CustomInpuText from '../../customInputText/CustomInputText'

import { useStyles } from './styles'
import YesyNoRadioGroup from '../../yesNoRadioGroup/YesNoRadioGroup'

const Step25 = ({
  btnAction,
  handleGoto,
  handleChange,
  handleCheckChange,
  data,
  cantItems,
  current,
}) => {
  const classes = useStyles()

  const validationsSchema = {
    workOrderNo: {
      valid: !data.noWorkOrderNo ? data.workOrderNo || false : true,
      errorMsg: 'Please fill this field.',
      validate: (value) => (!data.noWorkOrderNo ? value || false : true),
    },
    workOrderComments: {
      valid: data.workOrderComments || false,
      errorMsg: 'Please fill this field.',
      validate: (value) => value || false,
    },
    orderAditionalComments: {
      valid: data.orderAditionalComments || false,
      errorMsg: 'Please fill this field.',
      validate: (value) => value || false,
    },
    orderRecomend: {
      valid: data.orderRecomend || false,
      errorMsg: 'Please fill this field.',
      validate: (value) => value || false,
    },
  }

  const { errors, validate, validateAll } = useValidation(validationsSchema)

  const handleInternalChange = (evt) => {
    const { name, value } = evt.target
    handleChange(evt)
    validate(name, value)
  }

  const handleInternalBtnAction = (evt) => {
    if (validateAll()) {
      btnAction(evt)
    }
  }

  const handleInternalGoto = (index) => {
    if (index < data.step || validateAll()) {
      handleGoto(index)
    }
  }

  return (
    <Grid container spacing={3} className={classes.wrapper}>
      <Grid container item xs={12}>
        <p className='static-label'>
          Please give your Workorder confirmation number:
        </p>
        <CustomInpuText
          label='Workorder number'
          name='workOrderNo'
          value={data.workOrderNo || ''}
          onChange={handleInternalChange}
          required={!data.noWorkOrderNo}
          error={
            !data.noWorkOrderNo ? (errors?.workOrderNo ? true : false) : false
          }
          helperText={!data.noWorkOrderNo ? errors?.workOrderNo || '' : ''}
        />
        <FormControlLabel
          control={
            <Checkbox
              name='noWorkOrderNo'
              checked={data.noWorkOrderNo || false}
              onChange={handleCheckChange}
            />
          }
          label={'I do not have my work order number at this time.'}
        />
      </Grid>
      <Grid item xs={12}>
        <div className='static-label-wrapper'>
          <p className='static-label'>
            Was the work order completed to your satisfaction? Why or why not?
          </p>
        </div>
        <CustomInpuText
          placeholder='Type your answer...'
          multiline
          rows={3}
          required
          name='workOrderComments'
          value={data.workOrderComments}
          onChange={handleInternalChange}
          error={errors?.workOrderComments ? true : false}
          helperText={errors?.workOrderComments || ''}
        />
      </Grid>
      <Grid item xs={12}>
        <p className='static-label'>
          On a scale of 1-5 (5 being the highest), what would you rate today’s
          experience?
        </p>
        <FormControl fullWidth error={errors?.role ? true : false}>
          <InputLabel id='select-role-label'>Rate</InputLabel>
          <Select
            labelId='select-rate-label'
            id='select-rate'
            value={data.wordOrderRate || ''}
            label='Rate'
            name='wordOrderRate'
            required
            onChange={handleInternalChange}
          >
            {[...Array(5).keys()].map((i) => (
              <MenuItem key={`rate-${i}`} value={i + 1}>
                {i + 1}
              </MenuItem>
            ))}
          </Select>
          {errors?.role && <FormHelperText>{errors?.role}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <div className='static-label-wrapper'>
          <p className='static-label'>
            Is there anything else you would like to share about our
            service/personnel?
          </p>
        </div>
        <CustomInpuText
          placeholder='Type your answer...'
          multiline
          rows={3}
          required
          name='orderAditionalComments'
          value={data.orderAditionalComments}
          onChange={handleInternalChange}
          error={errors?.orderAditionalComments ? true : false}
          helperText={errors?.orderAditionalComments || ''}
        />
      </Grid>
      <Grid item xs={12}>
        <div className='static-label-wrapper'>
          <p className='static-label'>
            Was there something that you would recommend improving with regard
            to this interaction? Please explain
          </p>
        </div>
        <CustomInpuText
          placeholder='Type your answer...'
          multiline
          rows={3}
          required
          name='orderRecomend'
          value={data.orderRecomend}
          onChange={handleInternalChange}
          error={errors?.orderRecomend ? true : false}
          helperText={errors?.orderRecomend || ''}
        />
      </Grid>
      <Grid item xs={12}>
        <YesyNoRadioGroup
          title='Would you like to be contacted by one of our Managers regarding our services?'
          name='wantBeContactedByManagers'
          value={data.wantBeContactedByManagers}
          onChange={handleInternalChange}
        />
      </Grid>
      <Grid
        container
        item
        xs={12}
        sm={6}
        lg={6}
        justifyContent='center'
        alignItems='flex-end'
        sx={{ display: { sm: 'none', xs: 'flex' } }}
      >
        <Indicators cantItems={cantItems} current={current} handleGoto={handleInternalGoto} />
      </Grid>
      <Grid item xs={12} sm={6} lg={6} className={classes.btnWrapper}>
        <PrimaryButton onClick={handleInternalBtnAction}>Next</PrimaryButton>
      </Grid>
      <Grid
        container
        item
        xs={12}
        sm={6}
        lg={6}
        justifyContent='flex-end'
        alignItems='flex-end'
        sx={{ display: { sm: 'flex', xs: 'none' } }}
      >
        <Indicators
          cantItems={cantItems}
          current={current}
          handleGoto={handleInternalGoto}
        />
      </Grid>
    </Grid>
  )
}

export default Step25
